import { FC, useContext } from 'react';
import Link from 'next/link';
import { MobileMenuContext } from 'components/commercetools-ui/organisms/header/header-navigation/context/mobile-menu-context';
import ForwardIcon from 'icons/forward';
import { AmplienceHeaderNavProps } from '.';
import { gtmMenuNavigation } from 'helpers/utils/gtm-events/gtmInteraction';

const AmplienceHeaderNavMobile: FC<AmplienceHeaderNavProps> = ({ megaNavs }) => {
  const { setMegaNavSelected } = useContext(MobileMenuContext);
  return (
    <section className="h-[calc(100dvh_-_57px)] w-[90vw] overflow-y-auto bg-white font-extrabold">
      <ul>
        {megaNavs?.map(({ link, navColumns, title }, index) => (
          <li key={`header-nav-mobile-${title}-${index}`} className="flex items-center justify-between border-b p-5">
            <Link
              onClick={() => {
                gtmMenuNavigation({ click_location: 'header', click_name: title || '' });
              }}
              data-testid={`mega-nav-${title}-link`}
              href={link || ''}
              className="flex shrink-0 text-left text-sm font-semibold leading-[17px] text-[#222222]"
            >
              {title}
            </Link>
            <button
              data-testid={`mega-nav-arrow-${title}`}
              className="flex w-fit grow justify-end p-0"
              onClick={() => setMegaNavSelected({ link, navColumns, title })}
            >
              <ForwardIcon />
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default AmplienceHeaderNavMobile;
